module.exports = __webpack_public_path__ + "img/timeline_miscevent-17.d42fed3e.jpg";